module.exports = __webpack_public_path__ + "static/services-banner-dark-d314e3f5daa98fbada0f4b6d6b59dbbc.png";